<template>
  <v-container v-if="$apollo.loading">
    <v-progress-linear></v-progress-linear>
  </v-container>
  <v-container v-else>
    <h1 class="mb-3">{{ corporateChallenge.title }}</h1>
    <v-select v-model="selectedHeaders" :items="headers" label="Select Columns" multiple outlined return-object />
    <vue-json-to-csv :json-data="CSVData" csv-title="Corporate">
      <button>
        Download CSV
      </button>
    </vue-json-to-csv>
    <v-data-table
      :headers="selectedHeaders"
      :items="data"
      :items-per-page="200"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
      fixed-header
      height="100vh"
    >
      <template v-slot:item.client="{ item }">
        <router-link class="black--text font-weight-bold" :to="`/clients/${item.userId}`">
          {{ item.client }}
        </router-link>
      </template>
      <template v-slot:item.activity="{ item }">
        <client-week-dots :userId="item.userId" class="mb-1" show-arrows />
      </template>

      <template v-slot:item.engagement="{ item }">
        <engagement-score-circle :engagement-score="item.engagement" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { CORPORATE_CHALLENGE_VIEW_QUERY } from "@/graphql/queries/corporate";
import EngagementScoreCircle from "@/components/shared/EngagementScoreCircle";
import VueJsonToCsv from "vue-json-to-csv";
import ClientWeekDots from "@/components/client/blocks/progress/ClientWeekDots";

export default {
  name: "CorporateView",
  components: {
    EngagementScoreCircle,
    VueJsonToCsv,
    ClientWeekDots,
  },
  props: {
    corporateChallengeId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      data: [],
      CSVData: [],
      headers: [
        { text: "Client", value: "client", initiallyVisable: true },
        { text: "Gender", value: "gender", initiallyVisable: true },
        { text: "Activity", value: "activity", initiallyVisable: true },
        { text: "Blocks", value: "blocks", initiallyVisable: true },
        { text: "Coach", value: "coach", initiallyVisable: true },
        { text: "Nutrition", value: "nutrition", initiallyVisable: true },
        { text: "Engagement", value: "engagement", initiallyVisable: true },
        { text: "Groups", value: "groups", initiallyVisable: false },
        { text: "Chats", value: "chats", initiallyVisable: false },
        { text: "Outstanding Tasks", value: "outstandingTasks", initiallyVisable: false },
        { text: "Exercise Dots", value: "exerciseDots", initiallyVisable: true },
        { text: "Nutrition Dots", value: "nutritionDots", initiallyVisable: true },
        { text: "Mindset Dots", value: "mindsetDots", initiallyVisable: true },
        { text: "Hydration Logs", value: "hydrationLogs", initiallyVisable: true },
        { text: "Mood Logs", value: "moodLogs", initiallyVisable: true },
        { text: "Sleep Logs", value: "sleepLogs", initiallyVisable: true },
      ],
      selectedHeaders: [],
    };
  },
  created() {
    this.selectedHeaders = this.headers.filter((element) => element.initiallyVisable == true);
  },
  apollo: {
    corporateChallenge: {
      query: CORPORATE_CHALLENGE_VIEW_QUERY,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          id: this.corporateChallengeId,
        };
      },
      result(response) {
        if (response.data) {
          this.data = response.data.corporateChallenge.users.map((user) => {
            const groups = user.userProfile?.currentGroups?.map((group) => {
              return group.title;
            });
            const chats = user.userProfile?.currentChats?.map((chat) => {
              return chat.title;
            });

            const currentBlocks = user.userProfile?.currentBlocks?.map((block) => {
              return block.title;
            });

            return {
              userId: user.id,
              email: user.email,
              client: `${user.firstName} ${user.lastName}`,
              gender: `${user.userProfile?.gender}`,
              coach: user.userProfile?.coach
                ? `${user.userProfile?.coach?.firstName} ${user.userProfile?.coach?.lastName}`
                : "",
              groups: groups.join(", "),
              chats: chats.join(", "),
              outstandingTasks: user.userProfile.incompleteTasks,
              engagement: user.userProfile.engagementScore,
              blocks: currentBlocks.join(", "),
              nutrition: user.userProfile?.nutritionCurrentBlock?.title,
              exerciseDots: user.dots.exercise,
              nutritionDots: user.dots.nutrition,
              mindsetDots: user.dots.mindset,
              employeeCode: user.employeeCode ? user.employeeCode : "",
              hydrationLogs: user.userProfile.totalHydrationLogs,
              moodLogs: user.userProfile.totalMoodLogs,
              sleepLogs: user.userProfile.totalSleepLogs,
            };
          });
          this.loading = false;
          this.CSVData = [];

          this.data.forEach((item) => {
            const obj = JSON.parse(JSON.stringify(item));
            delete obj.userId;
            delete obj.coachId;
            this.CSVData.push(obj);
          });
        }
      },
    },
  },
};
</script>
